import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { FileUploadControl } from "../../../common/controls/file-upload-control";
import { FormLocationControl } from "../../../common/controls/form-location-control";
import common from "../../../../../common/mobile";
import { H3Upload, H3Dialog } from "h3-mobile-vue";
import axios from "axios";
import encryptApi from "@cloudpivot/common/src/utils/aes/index";
const suffix = ".jpg";
let Upload = class Upload extends FileUploadControl {
    constructor() {
        super(...arguments);
        this.previewVisible = false;
        this.previewImage = "";
        this.fileList = [];
        this.isAddWatermark = false;
        this.locationInfo = "";
        this.changing = false;
        this.showSignsture = false;
        this.filePreviewUrl = "";
    }
    // 打开表单的时候
    mounted() {
        // 如果仅拍照上传且有水印 就使用钉钉去定位
        this.isAddWatermark = !!this.controlOpts.addWatermark;
        if (!this.readonly) {
            this.getLoaction();
        }
    }
    get listType() {
        // 子表中图片上传显示成附件上传样式
        return this.isImage && !this.control.parentKey ? "photo-list" : "file";
    }
    get isOpenPreview() {
        return !this.getIsOpenPreview();
    }
    handleValueChange(value) {
        this.toFilelist(value);
    }
    setControl() {
        if (this.ctrl && this.ctrl.value) {
            this.toFilelist(this.ctrl.value);
            if (this.fileList.some((f) => f.base64)) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.upload.handleRefUpload();
                    }, 500);
                });
            }
        }
        else {
            this.fileList = [];
        }
        this.listenCommand();
    }
    toFilelist(val) {
        if (!val) {
            this.fileList = [];
            return;
        }
        //说明此时的数据还未经过转换
        if (Array.isArray(val) && val.length > 0 && val[0].mimeType) {
            val = this.convertFileData(val);
            if (!val)
                return;
        }
        if (val.some((x) => x.status !== 3 && x.status !== 2)) {
            // this.changing = false;
            return;
        }
        this.fileList = val
            .filter((x) => x.status === 2)
            .map((x, i) => {
            const idx = x.name.indexOf(suffix);
            if (idx > 0) {
                x.name = x.name.substring(0, idx) + i + suffix;
            }
            if (x.status === 2 && x.base64) {
                delete x.base64;
            }
            if (x.response && x.response.data) {
                x.url = this.getDownloadUrl(x.response.data);
            }
            return x;
        });
    }
    listenCommand() {
        const _this = this;
        this.commandSubscription = this.ctrl.commander.subscribe((cmd) => {
            switch (cmd.name) {
                case "clear":
                    _this.fileList = [];
                    _this.ctrl.value = null;
                    break;
                default:
                    break;
            }
        });
    }
    showError(msg) {
        this.$h3.toast.show({
            text: msg,
        });
    }
    showInfo(text) {
        this.$h3.toast.show({
            text,
            autoHide: true,
            iconType: "info",
            duration: 1000,
        });
    }
    getLoaction() {
        if (this.isAddWatermark) {
            FormLocationControl.service.position(undefined, false).then((result) => {
                this.locationInfo = result.address;
            });
        }
    }
    beforeUpload(files) {
        const file = files[0];
        if (!this.checkFileType(file.name, this.showError)) {
            return false;
        }
        if (!this.checkImageNumber(this.showError)) {
            return false;
        }
        return true;
    }
    onChange(info, files) {
        console.log("change", info);
        if (this.readonly) {
            return;
        }
        // this.changing = files.some(f => f.status !== 3 && f.status !== 2);
        // file: uid name size respone status type
        // status 1 准备上传 2 已上传 3上传失败 -1正在上传
        const fileList = files.map((f, i) => {
            return {
                uid: f.uid,
                name: f.name,
                size: f.size,
                type: f.type,
                status: f.status === -1 ? 1 : f.status,
                base64: f.base64,
                compressBase64: f.compressBase64,
                response: f.response,
            };
        });
        // .filter(f => f.status === 2);
        // .map(f => f.response.data);
        super.onFilesChange(fileList);
    }
    onRemovedImg(file) {
        super.removedFile(file);
    }
    handleCancel() {
        this.previewVisible = false;
    }
    joyChatOpenPDF(fileName, filePath, ext) {
        console.log("附件 showFile " + fileName);
        console.log("附件 showFile " + filePath);
        console.log("附件 showFile " + ext);
        //判断是否是joychat端
        const IS_JOYCHAT = /workplus/.test(navigator.userAgent);
        if (window.cordova && IS_JOYCHAT) {
            window.cordova.exec(function (result) {
                console.log(result);
            }, function (error) {
                console.log(error);
            }, "WorkPlus_Files", "showFile", [
                {
                    filePath: filePath,
                    fileName: fileName,
                    isImage: this.testIamge(ext) ? true : false,
                },
            ]);
        }
    }
    handlePreview(file) {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log("handlePreview =>", file);
            if (file.response) {
                const url = file.url ? file.url : _super("getPreviewUrl").call(this, file.response.data);
                const ext = this.getExt(file.name);
                if (this.testIamge(ext)) {
                    if (url === "") {
                        return;
                    }
                    else {
                        this.joyChatOpenPDF(file.name, url, ext);
                        // this.filePreviewUrl = url;
                        // platform.service.openLink(url);
                    }
                }
                else if (ext.toUpperCase().indexOf("PDF") !== -1) {
                    const KEY = window.config.encrypt_totalRewards.KEY;
                    const IV = window.config.encrypt_totalRewards.IV;
                    let refid = encodeURIComponent(encryptApi.encrypt_iv(file.response.data.refId, KEY, IV));
                    let res1 = yield axios.get(`/api/aliyun/preview/sign?refId=${refid}`);
                    let urlPDF = `${window.config.apiHost}/api/aliyun/preview?refId=${refid}&contentType=application/pdf`;
                    // let url = `${(window as any).config.apiHost}/api/aliyun/preview?refId=${file.response.data.refId}&contentType=application/pdf`
                    this.joyChatOpenPDF(file.name, urlPDF, ext);
                    // this.filePreviewUrl = url;
                    // platform.service.openLink(url);
                }
                else {
                    this.showError("Unable to preview this file, please download and view");
                }
            }
        });
    }
    filedownload(file) {
        // if (utils.Common.isWechat) {
        //   this.showError(`暂不支持下载`);
        //   return;
        // }
        file.response && super.download(file.response.data);
    }
    uploadError(err) {
        if (!err) {
            return;
        }
        let msg = "";
        switch (err) {
            // case 'overQuantity':
            //   this.showError(`一次最多允许上传张`);
            //   break;
            // case 'uploadError':
            //   this.showError(`文件错误`);
            //   break;
            case "overSize":
                msg = this.$t("cloudpivot.form.renderer.tip.overSize", {
                    label: this.limitSize,
                }).toString();
                this.showError(msg);
                break;
            default:
                msg = this.$t("cloudpivot.form.renderer.tip.uploadError").toString();
                this.showError(msg);
                // this.showError('上传失败请重试');
                break;
        }
    }
    destroyed() {
        super.destroyed();
        if (this.commandSubscription) {
            this.commandSubscription.unsubscribe();
        }
    }
    created() {
        this.init();
    }
    hideSignsture() {
        this.showSignsture = false;
    }
};
Upload = tslib_1.__decorate([
    Component({
        name: "upload",
        components: {
            H3Upload,
            H3Dialog,
        },
        directives: {
            TransferDom: common.directives.transferDom,
        },
    })
], Upload);
export default Upload;
